var React = require('react');

function IcoArrowRightBlackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#161615","fillRule":"nonzero","d":"m19.064.207 9.581 11.794-9.585 11.793-.964-1.187 7.987-9.828H.5v-1.557h25.587L18.1 1.394z"}));
}

IcoArrowRightBlackInline.defaultProps = {"width":"29","height":"24"};

module.exports = IcoArrowRightBlackInline;

IcoArrowRightBlackInline.default = IcoArrowRightBlackInline;
